import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getVideosByCategory } from "@/utils/videoHelpers";

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-12">
      <div className="mb-5">
        <h2 className="text-lg font-bold text-foreground-900 md:text-xl">分类快捷入口</h2>
        <p className="mt-1 text-sm text-foreground-500">从你喜欢的类别开始，发现更多有趣内容</p>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {categories.map((category) => {
          const count = getVideosByCategory(category.key).length;
          return (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100 p-4 transition hover:border-primary-300 hover:bg-background-50 md:p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-600 transition group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${category.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-3 text-base font-bold text-foreground-900 group-hover:text-primary-600">
                {category.name}短视频
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                {category.description}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-foreground-400">
                共 {count} 条内容
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}